import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ExteriorPaintingPage = lazy(() => import('../pages/exterior-painting/page'));
const FilmInstallationPage = lazy(() => import('../pages/film-installation/page'));
const FloorCoatingPage = lazy(() => import('../pages/floor-coating/page'));
const ReformPage = lazy(() => import('../pages/reform/page'));
const RenovationPage = lazy(() => import('../pages/renovation/page'));
const WorksPage = lazy(() => import('../pages/works/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/exterior-painting',
    element: <ExteriorPaintingPage />
  },
  {
    path: '/film-installation',
    element: <FilmInstallationPage />
  },
  {
    path: '/floor-coating',
    element: <FloorCoatingPage />
  },
  {
    path: '/reform',
    element: <ReformPage />
  },
  {
    path: '/renovation',
    element: <RenovationPage />
  },
  {
    path: '/works',
    element: <WorksPage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
